// Vendor libraries
import { createSelector } from '@ngrx/store';
export const getTargetRatesState = ({ appStateSliceKey, ...state }) => state[appStateSliceKey];
export const getShowRecessions = createSelector(getTargetRatesState, ({ showRecessions }) => showRecessions);
